// 配置哪一些属性需要跟随主题色改变
const themeColorProps: any = {
  ResumeTitle_1: {
    css: ['background'], // 主题样式需要设置为主题色的css属性
    customCss: {} // 自定义样式中，需要设置为主题色的prop，以及对应的css属性
  },
  ResumeTitle_2: {
    css: ['background'],
    customCss: {}
  },
  ResumeTitle_3: {
    css: ['background'], // 主题样式需要设置为主题色的css属性
    customCss: {} // 自定义样式中，需要设置为主题色的prop，以及对应的css属性
  },
  BaseInfo_3: {
    css: [],
    customCss: {}
  },
  BaseInfo_4: {
    css: [],
    customCss: {
      userInfoBlock: ['background', 'backgroundColor']
    }
  },
  BaseInfo_9: {
    css: [],
    customCss: {
      elSliderBar: ['background']
    }
  },
  BaseInfo_10: {
    css: [],
    customCss: {
      nameAbstractBox: ['background']
    }
  },
  BaseInfo_11: {
    css: [],
    customCss: {}
  },
  BaseInfo_12: {
    css: [],
    customCss: {
      leftTopBox: ['background']
    }
  },
  BaseInfo_13: {
    css: [],
    customCss: {
      topBgcStyle: ['background', 'backgroundColor']
    }
  },
  JobIntention_1: {
    css: [],
    customCss: {}
  },
  JobIntention_2: {
    css: [],
    customCss: {}
  },
  JobIntention_3: {
    css: [],
    customCss: {}
  },
  JobIntention_4: {
    css: [],
    customCss: {}
  },
  JobIntention_5: {
    css: [],
    customCss: {}
  },
  JobIntention_6: {
    css: [],
    customCss: {}
  },
  JobIntention_7: {
    css: [],
    customCss: {}
  },
  JobIntention_8: {
    css: [],
    customCss: {}
  },
  JobIntention_9: {
    css: [],
    customCss: {}
  },
  JobIntention_10: {
    css: [],
    customCss: {}
  },
  EduBackground_1: {
    css: [],
    customCss: {}
  },
  EduBackground_2: {
    css: [],
    customCss: {}
  },
  EduBackground_3: {
    css: [],
    customCss: {}
  },
  EduBackground_4: {
    css: [],
    customCss: {}
  },
  EduBackground_5: {
    css: [],
    customCss: {}
  },
  EduBackground_6: {
    css: [],
    customCss: {}
  },
  EduBackground_7: {
    css: [],
    customCss: {}
  },
  EduBackground_8: {
    css: [],
    customCss: {}
  },
  EduBackground_9: {
    css: [],
    customCss: {}
  },
  EduBackground_10: {
    css: [],
    customCss: {}
  },
  EduBackground_11: {
    css: [],
    customCss: {}
  },
  EduBackground_12: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_1: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_2: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_3: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_4: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_5: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_6: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_7: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_8: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_9: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_10: {
    css: [],
    customCss: {}
  },
  SkillSpecialties_11: {
    css: [],
    customCss: {
      elSliderBar: ['background']
    }
  },
  SkillSpecialties_12: {
    css: [],
    customCss: {
      elSliderBar: ['background']
    }
  },
  SkillSpecialties_13: {
    css: [],
    customCss: {
      elSliderBar: ['background']
    }
  },
  SkillSpecialties_14: {
    css: [],
    customCss: {
      elSliderBar: ['background']
    }
  },
  SkillSpecialties_15: {
    css: [],
    customCss: {
      elSliderBar: ['background']
    }
  },
  SkillSpecialties_16: {
    css: [],
    customCss: {
      elSliderBar: ['background']
    }
  },
  CampusExperience_1: {
    css: [],
    customCss: {}
  },
  CampusExperience_2: {
    css: [],
    customCss: {}
  },
  CampusExperience_3: {
    css: [],
    customCss: {}
  },
  CampusExperience_4: {
    css: [],
    customCss: {}
  },
  CampusExperience_5: {
    css: [],
    customCss: {}
  },
  CampusExperience_6: {
    css: [],
    customCss: {}
  },
  CampusExperience_7: {
    css: [],
    customCss: {}
  },
  CampusExperience_8: {
    css: [],
    customCss: {}
  },
  CampusExperience_9: {
    css: [],
    customCss: {}
  },
  CampusExperience_10: {
    css: [],
    customCss: {}
  },
  CampusExperience_11: {
    css: [],
    customCss: {}
  },
  InternshipExperience_1: {
    css: [],
    customCss: {}
  },
  InternshipExperience_2: {
    css: [],
    customCss: {}
  },
  InternshipExperience_3: {
    css: [],
    customCss: {}
  },
  InternshipExperience_4: {
    css: [],
    customCss: {}
  },
  InternshipExperience_5: {
    css: [],
    customCss: {}
  },
  InternshipExperience_6: {
    css: [],
    customCss: {}
  },
  InternshipExperience_7: {
    css: [],
    customCss: {}
  },
  InternshipExperience_8: {
    css: [],
    customCss: {}
  },
  InternshipExperience_9: {
    css: [],
    customCss: {}
  },
  InternshipExperience_10: {
    css: [],
    customCss: {}
  },
  InternshipExperience_11: {
    css: [],
    customCss: {}
  },
  WorkExperience_1: {
    css: [],
    customCss: {}
  },
  WorkExperience_2: {
    css: [],
    customCss: {}
  },
  WorkExperience_3: {
    css: [],
    customCss: {}
  },
  WorkExperience_4: {
    css: [],
    customCss: {}
  },
  WorkExperience_5: {
    css: [],
    customCss: {}
  },
  WorkExperience_6: {
    css: [],
    customCss: {}
  },
  WorkExperience_7: {
    css: [],
    customCss: {}
  },
  WorkExperience_8: {
    css: [],
    customCss: {}
  },
  WorkExperience_9: {
    css: [],
    customCss: {}
  },
  WorkExperience_10: {
    css: [],
    customCss: {}
  },
  WorkExperience_11: {
    css: [],
    customCss: {}
  },
  ProjectExperience_1: {
    css: [],
    customCss: {}
  },
  ProjectExperience_2: {
    css: [],
    customCss: {}
  },
  ProjectExperience_3: {
    css: [],
    customCss: {}
  },
  ProjectExperience_4: {
    css: [],
    customCss: {}
  },
  ProjectExperience_5: {
    css: [],
    customCss: {}
  },
  ProjectExperience_6: {
    css: [],
    customCss: {}
  },
  ProjectExperience_7: {
    css: [],
    customCss: {}
  },
  ProjectExperience_8: {
    css: [],
    customCss: {}
  },
  ProjectExperience_9: {
    css: [],
    customCss: {}
  },
  ProjectExperience_10: {
    css: [],
    customCss: {}
  },
  ProjectExperience_11: {
    css: [],
    customCss: {}
  },
  Awards_1: {
    css: [],
    customCss: {}
  },
  Awards_2: {
    css: [],
    customCss: {}
  },
  Awards_3: {
    css: [],
    customCss: {}
  },
  Awards_4: {
    css: [],
    customCss: {}
  },
  Awards_5: {
    css: [],
    customCss: {}
  },
  Awards_6: {
    css: [],
    customCss: {}
  },
  Awards_7: {
    css: [],
    customCss: {}
  },
  Awards_8: {
    css: [],
    customCss: {}
  },
  Awards_9: {
    css: [],
    customCss: {}
  },
  Awards_10: {
    css: [],
    customCss: {}
  },
  Awards_11: {
    css: [],
    customCss: {}
  },
  Awards_12: {
    css: [],
    customCss: {}
  },
  Hobbies_1: {
    css: [],
    customCss: {}
  },
  Hobbies_2: {
    css: [],
    customCss: {}
  },
  Hobbies_3: {
    css: [],
    customCss: {}
  },
  Hobbies_4: {
    css: [],
    customCss: {}
  },
  Hobbies_5: {
    css: [],
    customCss: {}
  },
  Hobbies_6: {
    css: [],
    customCss: {}
  },
  Hobbies_7: {
    css: [],
    customCss: {}
  },
  Hobbies_8: {
    css: [],
    customCss: {}
  },
  Hobbies_9: {
    css: [],
    customCss: {}
  },
  Hobbies_10: {
    css: [],
    customCss: {}
  },
  Hobbies_11: {
    css: [],
    customCss: {}
  },
  Hobbies_12: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_1: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_2: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_3: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_4: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_5: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_6: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_7: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_8: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_9: {
    css: [],
    customCss: {}
  },
  SelfEvaluation_10: {
    css: [],
    customCss: {}
  },
  WorksDisplay_1: {
    css: [],
    customCss: {}
  },
  WorksDisplay_2: {
    css: [],
    customCss: {}
  },
  WorksDisplay_3: {
    css: [],
    customCss: {}
  },
  WorksDisplay_4: {
    css: [],
    customCss: {}
  },
  WorksDisplay_5: {
    css: [],
    customCss: {}
  },
  WorksDisplay_6: {
    css: [],
    customCss: {}
  },
  WorksDisplay_7: {
    css: [],
    customCss: {}
  },
  WorksDisplay_8: {
    css: [],
    customCss: {}
  },
  WorksDisplay_9: {
    css: [],
    customCss: {}
  },
  WorksDisplay_10: {
    css: [],
    customCss: {}
  },
  Custom_2: {
    css: [],
    customCss: {}
  },
  Custom_3: {
    css: ['background'],
    customCss: {}
  }
};

// 模块标题主题色配置
export const moduleTitleThemeProps: any = {
  ModuleTitle_1: {
    moduleTitle: ['borderColor']
  },
  ModuleTitle_2: {},
  ModuleTitle_3: {
    moduleTitle: ['color', 'borderColor'],
    moduleTitleFont: ['color', 'borderColor']
  },
  ModuleTitle_4: {
    moduleTitle: ['borderColor', 'color', 'borderColor']
  },
  ModuleTitle_5: {
    moduleTitle: ['color', 'borderColor'],
    moduleTitleFont: ['color', 'borderColor'],
    moduleTitleIcon: ['background']
  },
  ModuleTitle_6: {
    moduleTitle: ['borderColor'],
    moduleTitleFontBox: ['background', 'backgroundColor']
  },
  ModuleTitle_7: {
    moduleTitle: ['color']
  },
  ModuleTitle_8: {
    moduleTitle: ['color']
  },
  ModuleTitle_9: {
    moduleTitle: ['borderColor', 'color'],
    moduleTitleIcon: ['background'],
    moduleTitleRightBox: ['borderColor']
  },
  ModuleTitle_10: {
    moduleTitle: ['color', 'borderColor'],
    moduleTitleFont: ['color', 'borderColor']
  },
  ModuleTitle_11: {
    moduleTitle: ['color']
  },
  ModuleTitle_12: {
    moduleTitle: ['color']
  },
  ModuleTitle_13: {
    moduleTitleFont: ['color'],
    moduleTitleIcon: ['color']
  },
  ModuleTitle_14: {
    moduleTitle: ['borderColor', 'color']
  },
  ModuleTitle_15: {
    moduleTitleFont: ['background']
  },
  ModuleTitle_16: {
    moduleTitleFont: ['background', 'backgroundColor']
  },
  ModuleTitle_17: {
    moduleTitleFont: ['background', 'backgroundColor']
  },
  ModuleTitle_18: {
    moduleTitle: ['background', 'backgroundColor']
  },
  ModuleTitle_19: {
    moduleTitle: ['background', 'backgroundColor']
  }
};
export default themeColorProps;
